"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
/**
 * Permanent (e.g., device IDs, MAC address) or temporary (e.g., IP address)
 * identifiers needed to establish a connection for the current browsing session.
 */
exports.ConnectionSubCategory = (0, type_utils_1.makeEnum)({
    /** A Media Access Control address */
    MACAddress: 'MAC_ADDRESS',
    /** An internet protocol address */
    IPAddress: 'IP_ADDRESS',
    /** The User-Agent request header */
    UserAgent: 'USER_AGENT',
    /** Fallback subcategory */
    Connection: 'CONNECTION',
});
//# sourceMappingURL=connection.js.map